export const SET_USERS = "SET_USERS";
export const SET_DETAIL_USER = "SET_DETAIL_USER";
export const SET_TYPES_IDENTIFICATION = "SET_TYPES_IDENTIFICATION";
export const SET_GENDERS = "SET_GENDERS";
export const SET_CIVIL_STATUS = "SET_CIVIL_STATUS";
export const SET_TYPES_EPS = "SET_TYPES_EPS";
export const SET_TYPES_AFP = "SET_TYPES_AFP";
export const SET_TYPES_ARL = "SET_TYPES_ARL";
export const SET_TYPES_CCF = "SET_TYPES_CCF";
export const SET_STATE_USER = "SET_STATE_USER";
export const SET_DIALOG_ACTIVE = "SET_DIALOG_ACTIVE";
export const SET_USER_DETAIL_FIELDS = "SET_USER_DETAIL_FIELDS";
export const SET_USER_PRODUCT_DETAIL_FIELDS = "SET_USER_PRODUCT_DETAIL_FIELDS";
export const SET_EPS = "SET_EPS";
export const SET_AFP = "SET_AFP";
export const SET_ARL = "SET_ARL";
export const SET_CCF = "SET_CCF";